import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ActionState } from 'src/app/features/action-center/types/action-center-types';
import { ActionCenterService } from 'src/app/features/action-center/service/action-center.service';

@Component({
    selector: 'app-row-menu',
    templateUrl: './row-action.component.html',
    styleUrls: ['./row-action.component.scss'],
    standalone: false
})
export class RowActionComponent implements OnInit {
    @Input() recName: string = '';
    @Input() recId: string = '';
    @Input() currPageState: ActionState | undefined = undefined;

    @Output() actionMoved: EventEmitter<ActionState> = new EventEmitter<ActionState>();
    @Output() displayLoader: EventEmitter<boolean> = new EventEmitter<boolean>();

    additionalInfo: any = {};

    menuOptions: { title: string, included_in: Array<ActionState> }[] = [
        { title: 'Move to My Actions', included_in: [ActionState.Dismissed, ActionState.Recommended, ActionState.Snoozed] },
        { title: 'View Details', included_in: [ActionState.Completed, ActionState.Dismissed, ActionState.MyActions, ActionState.Recommended, ActionState.Snoozed] },
        { title: 'Mark as Complete', included_in: [ActionState.MyActions] },
        { title: 'Dismiss', included_in: [ActionState.MyActions, ActionState.Recommended] },
        { title: 'Snooze', included_in: [ActionState.MyActions, ActionState.Recommended] },
    ]

    optionsToShow: { title: string }[] = [];
    displayCover: boolean = false;
    popUpFor: '' | 'snooze' | 'dismiss' = '';

    constructor(private router: Router, private acService: ActionCenterService) { }

    ngOnInit(): void {
        this.optionsToShow = this.menuOptions.filter(option => option.included_in.includes(this.currPageState as ActionState)).map(option => { return { title: option.title } });
    }

    async onClick(action: string) {
        switch (action) {
            case 'Move to My Actions':
                await this.moveAction(ActionState.MyActions);
                break;
            case 'Mark as Complete':
                await this.moveAction(ActionState.Completed);
                break;
            case 'Dismiss':
                this.displayCover = true;
                this.popUpFor = 'dismiss';
                break;
            case 'Snooze':
                this.displayCover = true;
                this.popUpFor = 'snooze';
                break;
            case 'View Details':
                this.router.navigate(['./action-details/' + this.recId]);
                break;
            default:
                break;
        }
    }

    async submitForm(params: { sumissionType: string, submissionValue: string | undefined }) {
        switch (params.sumissionType) {
            case 'snooze':
                this.additionalInfo = { snoozeDuration: params.submissionValue };
                await this.moveAction(ActionState.Snoozed);
                break;
            case 'dismiss':
                this.additionalInfo = { dismissalReason: params.submissionValue };
                await this.moveAction(ActionState.Dismissed);
                break;
            case 'close':
                this.displayCover = false;
                this.popUpFor = '';
                break;
            default:
                throw new Error('Invalid submission type');
        }
    }

    public async moveAction(newAction: ActionState | undefined) {
        if (newAction !== undefined && this.currPageState !== undefined) {
            this.displayLoader.emit(true);
            let success = await this.acService.moveActionToDifferentState(this.recId, this.currPageState, newAction, this.additionalInfo);
            this.additionalInfo = {};
            this.displayLoader.emit(false);
            if (success) this.actionMoved.emit(newAction);
            else alert('Failed to move action');
        }
    }
}